import { render } from "./multilingual.vue?vue&type=template&id=2cce19bc"
import script from "./multilingual.vue?vue&type=script&lang=js"
export * from "./multilingual.vue?vue&type=script&lang=js"

import "./multilingual.vue?vue&type=style&index=0&id=2cce19bc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__